import { useCallback, useMemo } from 'react';

export const useLocalizedCurrency = (value: string | number | undefined | null, currency: string = 'USD'): string => {
    const getLanguage = useCallback(() => 'en', []);

    const notAvailableMessage = useMemo(() => 'N/A', []);

    return useMemo(() => {
        if (value === undefined || value === null) {
            return notAvailableMessage;
        }

        return new Intl.NumberFormat(getLanguage(), { style: 'currency', currency }).format(Number(value));
    }, [value, currency, getLanguage, notAvailableMessage]);
};
